import { React, useState, useEffect, useLayoutEffect, useRef } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TableContainer,
  TextField,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import Close from "@mui/icons-material/Close";
import Refresh from "@mui/icons-material/Refresh";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { useReactToPrint } from "react-to-print";

import { useQuery, useSubscription } from "@apollo/client";
import { FETCH_INSURANCE } from "../../../graphql/query/query";
import HocPopup from "../../../hoc/hocPopup";
import { CustomerStyle } from "./Customers.styles";
import { useAuth } from "../../../context/Auth.context";
import { useParams } from "react-router-dom";
import CustomerCartComponent from "./card/CustomerCart.component";
import { useAppContext } from "../../../context/App.context";
import useDebounce from "../../../hook/useDebounce";
import { ON_FETCH_INSURANCE } from "../../../graphql/subscription/subscription";
import { formatToDate, capitalizeFirstLetter } from "../../../utils/Utils";

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const INITIAL_FILTER = {
  employee: "",
  startDate: moment(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  ).format("MM/DD/YYYY"),
  endDate: moment(
    new Date().toLocaleString("en-US", {
      timeZone: userTimezone,
    })
  ).format("MM/DD/YYYY"),
  searchCustomer: "",
};

const CustomersListComponent = () => {
  const auth = useAuth();
  const app = useAppContext();
  const params = useParams();

  const [page, setPage] = useState(0);
  const [count, setCount] = useState(10000);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [tableData, setTableData] = useState([]);

  const [filterData, setFilterData] = useState(INITIAL_FILTER);
  const [searchEmployee, setSearchEmployee] = useState(null);
  const [searchCustomer, setSearchCustomer] = useState(null);
  const [checkService, setCheckService] = useState({
    insurance: true,
    knowledgeHub: false,
    prequal: false,
    idVerfication: false,
  });
  const [walkthrough, setWalkthrough] = useState(null);

  const printRef = useRef();

  const [fetchInput, setFetchInput] = useState({
    f_startDate: moment(filterData.startDate).format("YYYY-MM-DD"),
    f_endDate: moment(filterData.endDate).format("YYYY-MM-DD"),
    search_employee: filterData.employee || null,
    search_customer: filterData.searchCustomer,
    rowsPerPage: rowsPerPage,
    pageCount: page,
    dealership_id: auth.user.dealership_id,
    employee_user_id: parseInt(params.employeeId) || auth.user.user_id,
    isEmployeeOnly:
      auth.user.loggedInAs === "employee" || params.employeeId ? true : false,
    timezone: new Date().getTimezoneOffset(),
  });

  useEffect(() => {
    if (auth?.user?.dealershipServices?.length > 0) {
      console.log("serviceRunning");
      auth?.user?.dealershipServices?.forEach((item) => {
        if (item?.service_id === 1) {
          setCheckService((prev) => ({
            ...prev,
          }));
        } else if (item?.service_id === 2) {
          setCheckService((prev) => ({
            ...prev,
            knowledgeHub: true,
          }));
        } else if (item?.service_id === 3) {
          setCheckService((prev) => ({
            ...prev,
            prequal: true,
          }));
        } else if (item?.service_id === 4) {
          setCheckService((prev) => ({
            ...prev,
            idVerfication: true,
          }));
        }
      });
    }
    if (auth?.user?.associateDetails?.length > 0) {
      const isWalkthrough = auth?.user?.associateDetails?.find(
        (dealership) => dealership?.dealership_id === auth?.user?.dealership_id
      );

      let getWalkthroughVideo =
        isWalkthrough?.walkthrough_video?.video_url ||
        isWalkthrough?.walkthrough_video?.es_video_url ||
        isWalkthrough?.walkthrough_video?.text ||
        isWalkthrough?.walkthrough_video?.es_text ||
        isWalkthrough?.walkthrough_video?.knowledgehub_video_url ||
        isWalkthrough?.walkthrough_video?.es_knowledgehub_video_url ||
        isWalkthrough?.walkthrough_video?.knowledgehub_text ||
        isWalkthrough?.walkthrough_video?.es_knowledgehub_text
          ? true
          : false;
      console.log("getWalkthroughVideo: ", getWalkthroughVideo);
      setWalkthrough(getWalkthroughVideo);
    }
  }, []);

  const {
    data: insuranceData,
    loading,
    refetch,
  } = useQuery(FETCH_INSURANCE, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    variables: {
      fetchInsuranceInput: fetchInput,
    },
  });
  console.log("insuranceData", insuranceData);
  const { data: onFetchInsurance } = useSubscription(ON_FETCH_INSURANCE, {
    variables: {
      dealership_id: auth.user.dealership_id,
      // employee_user_id: parseInt(params.employeeId) || auth.user.user_id,
    },
  });
  console.log("onfetchInsurance", onFetchInsurance);

  useEffect(() => {
    setFetchInput({
      ...fetchInput,
      pageCount: page,
      rowsPerPage: rowsPerPage,
    });
  }, [page, rowsPerPage]);

  useEffect(() => {
    let name = null;
    if (auth.user?.user_id && app?.target && app.target.length > 0) {
      if (auth.user.loggedInAs === "manager" && params.employeeId) {
        let employee = app.target.filter((person) => {
          let userId = params.employeeId
            ? parseInt(params.employeeId)
            : auth.user.user_id;
          return person.employeeId === userId;
        });
        name = employee[0]?.last_name;
      }
    } else if (auth.user?.user_id) {
      name = auth.user.last_name;
    }
    if (name)
      setFilterData({
        ...filterData,
        employee: name,
      });
  }, []);

  useLayoutEffect(() => {
    if (insuranceData?.fetchInsuranceRecord?.customers) {
      let getEmployeeData = null;
      if (auth.user.loggedInAs === "manager" && params.employeeId) {
        getEmployeeData =
          insuranceData?.fetchInsuranceRecord?.customers?.filter((data) => {
            console.log("recorddddddddwww", data?.employee?.employee_user_id);
            return (
              parseInt(params?.employeeId) === data?.employee?.employee_user_id
            );
          });
        console.log(
          "recordddddddd",

          params?.employeeId,
          getEmployeeData
        );
      } else if (auth?.user?.loggedInAs === "employee") {
        getEmployeeData =
          insuranceData?.fetchInsuranceRecord?.customers?.filter((data) => {
            console.log("dataaaarecord", data?.employee?.employee_user_id);
            let userId = parseInt(auth?.user?.user_id);
            console.log("userIdemployee", userId);
            return parseInt(data?.employee?.employee_user_id) === userId;
          });
      } else if (auth?.user?.loggedInAs === "employee") {
        getEmployeeData =
          insuranceData?.fetchInsuranceRecord?.customers?.filter((data) => {
            console.log("dataaaarecord", data?.employee?.employee_user_id);
            let userId = parseInt(auth?.user?.user_id);
            console.log("userIdemployee", userId);
            return parseInt(data?.employee?.employee_user_id) === userId;
          });
      }
      console.log("getEmployeeData", getEmployeeData);
      if (getEmployeeData) {
        setTableData((prevTableData) => getEmployeeData);
        setCount(insuranceData.fetchInsuranceRecord.total);
      } else {
        setTableData((prevTableData) => [
          ...insuranceData.fetchInsuranceRecord.customers,
        ]);
        setCount(insuranceData.fetchInsuranceRecord.total);
      }
    }
    // if (auth.user.loggedInAs === "employee")
    app.setFetchData({
      ...app.fetchData,
      f_startDate: fetchInput.f_startDate,
      f_endDate: fetchInput.f_endDate,
      pageCount: fetchInput.pageCount,
      rowsPerPage: fetchInput.rowsPerPage,
      searchCustomer: fetchInput.search_customer,
      searchEmployee: fetchInput.search_employee,
    });
  }, [insuranceData]);
  useLayoutEffect(() => {
    if (onFetchInsurance?.onFetchInsurance?.insurance_details?.customers) {
      console.log("employeeUserID", onFetchInsurance?.onFetchInsurance);

      let getEmployeeId = null;
      if (auth.user.loggedInAs === "manager" && params.employeeId) {
        getEmployeeId =
          onFetchInsurance?.onFetchInsurance?.insurance_details?.customers?.filter(
            (data) => {
              console.log("dataaaa", data?.employee?.employee_user_id);
              let userId = parseInt(params?.employeeId);
              console.log("userId", userId);
              return parseInt(data?.employee?.employee_user_id) === userId;
            }
          );
        console.log("paramsUSerId", params?.employeeId);
      } else if (auth?.user?.loggedInAs === "employee") {
        getEmployeeId =
          onFetchInsurance?.onFetchInsurance?.insurance_details?.customers?.filter(
            (data) => {
              console.log("dataaaa", data?.employee?.employee_user_id);
              let userId = parseInt(auth?.user?.user_id);
              console.log("userId", userId);
              return parseInt(data?.employee?.employee_user_id) === userId;
            }
          );
      }

      console.log("getEmployeeId", getEmployeeId);
      if (getEmployeeId) {
        setTableData((prevTableData) => getEmployeeId);
        setCount(onFetchInsurance?.onFetchInsurance?.insurance_details?.total);
      } else {
        setTableData((prevTableData) => [
          ...onFetchInsurance?.onFetchInsurance?.insurance_details?.customers,
        ]);
        setCount(onFetchInsurance?.onFetchInsurance?.insurance_details?.total);
      }
    }
    // if (auth.user.loggedInAs === "employee")
    app.setFetchData({
      ...app.fetchData,
      f_startDate: fetchInput.f_startDate,
      f_endDate: fetchInput.f_endDate,
      pageCount: fetchInput.pageCount,
      rowsPerPage: fetchInput.rowsPerPage,
      searchCustomer: fetchInput.search_customer,
      searchEmployee: fetchInput.search_employee,
    });
  }, [onFetchInsurance]);
  console.log("onFetchInsurance", onFetchInsurance);
  useDebounce(
    () => {
      setTableData([]);
      setFetchInput({
        ...fetchInput,
        search_employee:
          searchEmployee && searchEmployee.length > 0 ? searchEmployee : null,
        search_customer:
          searchCustomer && searchCustomer.length > 0 ? searchCustomer : null,
      });
    },
    1000,
    [searchEmployee, searchCustomer]
  );

  tableData.sort((a, b) => {
    const dateA = new Date(a.customer?.date);
    const dateB = new Date(b.customer?.date);
    return dateB - dateA;
  });
  console.log("tabledata", tableData);

  // Same pattern as ManagerComponent: render a printable, off-screen
  // version of the table and hand its ref to react-to-print. The
  // browser's print dialog (Save as PDF) produces the output, so
  // nothing extra needs to be installed.
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Customer_Report_${moment().format("YYYY-MM-DD")}`,
    pageStyle: `
      @page { size: landscape; margin: 12mm; }
      @media print {
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    `,
  });

  const handleReset = () => {
    setTableData([]);
    setFilterData(INITIAL_FILTER);
    setSearchEmployee(null);
    setSearchCustomer(null);
    setPage(0);
    setFetchInput({
      ...fetchInput,
      f_startDate: moment(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      ).format("YYYY-MM-DD"),
      f_endDate: moment(new Date()).format("YYYY-MM-DD"),
      search_employee: null,
      search_customer: null,
      pageCount: 0,
    });
    refetch();
    console.log("filterdattt", filterData);
  };

  return (
    <Box px={2}>
      <Paper
        sx={
          auth.user.loggedInAs === "manager"
            ? CustomerStyle.wrapper
            : CustomerStyle.wrapperEmpl
        }
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={CustomerStyle.noValidate}
        >
          <FormControl
            // sx={CustomerStyle.salesPerson}
            variant="outlined"
            fullWidth
            disabled={Boolean(params.employeeId)}
          >
            <InputLabel>Employee</InputLabel>
            <OutlinedInput
              label="Employee"
              value={filterData.employee}
              type="text"
              onChange={(event) => {
                setFilterData({
                  ...filterData,
                  employee: event.target.value,
                });
                setSearchEmployee(event.target.value);
                setTableData([]);
              }}
              endAdornment={
                auth.user.loggedInAs === "manager" && !params.employeeId && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setFilterData({
                          ...filterData,
                          employee: "",
                        });
                        setSearchEmployee(null);
                        setTableData([]);
                      }}
                      edge="end"
                    >
                      {filterData.employee ? <Close /> : ""}
                    </IconButton>
                  </InputAdornment>
                )
              }
            />
          </FormControl>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Start Date"
              value={filterData.startDate}
              maxDate={new Date()}
              onChange={(event) => {
                setFilterData({
                  ...filterData,
                  startDate: moment(event).format("MM/DD/YYYY"),
                });
                setFetchInput({
                  ...fetchInput,
                  f_startDate: moment(event).format("YYYY-MM-DD"),
                });
              }}
              renderInput={(params) => (
                <TextField fullWidth sx={CustomerStyle.textField} {...params} />
              )}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton edge="end">
                    <EventIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="End Date"
              value={filterData.endDate}
              minDate={new Date(filterData.startDate)}
              maxDate={new Date()}
              onChange={(event) => {
                setFilterData({
                  ...filterData,
                  endDate: moment(event).format("MM/DD/YYYY"),
                });
                setFetchInput({
                  ...fetchInput,
                  f_endDate: moment(event).format("YYYY-MM-DD"),
                });
                setTableData([]);
              }}
              renderInput={(params) => (
                <TextField fullWidth sx={CustomerStyle.textField} {...params} />
              )}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton edge="end">
                    <EventIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </LocalizationProvider>
          <FormControl fullWidth variant="outlined">
            <InputLabel>Search Customer Name</InputLabel>
            <OutlinedInput
              label="Search Customer Name"
              value={filterData.searchCustomer}
              type="text"
              onChange={(event) => {
                setFilterData({
                  ...filterData,
                  searchCustomer: event.target.value,
                });
                setSearchCustomer(event.target.value);
                setTableData([]);
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      setFilterData({
                        ...filterData,
                        searchCustomer: "",
                      });
                      setSearchCustomer(null);
                    }}
                    edge="end"
                  >
                    {filterData.searchCustomer ? <Close /> : ""}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>

          {/* Print + Reset buttons, placed right after Search Customer Name,
              styled the same as ManagerComponent's Reset/Export buttons.
              Only shown for employee logins. */}
          {auth.user.loggedInAs === "employee" && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexShrink: 0,
              }}
            >
              <Button
                onClick={handleReset}
                startIcon={<RestartAltIcon sx={{ fontSize: 16 }} />}
                variant="outlined"
                size="small"
                sx={{
                  height: "36px",
                  textTransform: "none",
                  fontSize: "13px",
                  fontWeight: 700,
                  borderColor: "#BDBDBD",
                  color: "#616161",
                  whiteSpace: "nowrap",
                  px: "12px",
                }}
              >
                Reset
              </Button>

              <Button
                onClick={handlePrint}
                startIcon={<PrintOutlinedIcon sx={{ fontSize: 16 }} />}
                variant="outlined"
                size="small"
                disabled={tableData.length === 0}
                sx={{
                  height: "36px",
                  textTransform: "none",
                  fontSize: "13px",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  px: "12px",
                }}
              >
                Print
              </Button>
            </Box>
          )}
        </Box>

        <TableContainer
          sx={{
            maxHeight:
              auth.user.loggedInAs === "manager"
                ? window.innerHeight >= 1440
                  ? "80vh"
                  : window.innerHeight >= 1050
                  ? "75vh"
                  : window.innerHeight >= 900
                  ? "67vh"
                  : "59vh"
                : window.innerHeight >= 1440
                ? "72vh"
                : window.innerHeight >= 1050
                ? "65vh"
                : window.innerHeight >= 900
                ? "57vh"
                : "46vh",
            height:
              auth.user.loggedInAs === "manager"
                ? window.innerHeight >= 1440
                  ? "80vh"
                  : window.innerHeight >= 1050
                  ? "75vh"
                  : window.innerHeight >= 900
                  ? "67vh"
                  : "59vh"
                : window.innerHeight >= 1440
                ? "60vh"
                : window.innerHeight >= 1050
                ? "50vh"
                : window.innerHeight >= 900
                ? "57vh"
                : "46vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={CustomerStyle.tableCell}>
                  Date <br /> Time
                </TableCell>
                {auth.user.loggedInAs === "manager" && !params.employeeId && (
                  <TableCell sx={CustomerStyle.tableCell}>Employee</TableCell>
                )}
                <TableCell sx={CustomerStyle.tableCell}>Customer</TableCell>
                <TableCell sx={CustomerStyle.tableCell}>
                  Insurance Verified
                </TableCell>
                {checkService?.knowledgeHub && (
                  <TableCell sx={CustomerStyle.tableCell}>
                    Knowledge Hub
                  </TableCell>
                )}
                {checkService?.idVerfication && (
                  <TableCell sx={CustomerStyle.tableCell}>
                    ID Verified (P/F)
                  </TableCell>
                )}
                {checkService?.prequal && (
                  <TableCell sx={CustomerStyle.tableCell}>
                    PreQual Run
                  </TableCell>
                )}
                <TableCell sx={CustomerStyle.tableCell}>Review</TableCell>
                <TableCell sx={CustomerStyle.tableCell}>Satisfied</TableCell>
                <TableCell sx={CustomerStyle.tableCell}>Appointment</TableCell>
                <TableCell sx={CustomerStyle.tableCell}>Referral</TableCell>
                <TableCell sx={CustomerStyle.tableCell}>Apps</TableCell>

                <TableCell sx={CustomerStyle.tableCell}>
                  Insurance <br /> Carrier
                </TableCell>
                <TableCell sx={CustomerStyle.tableCell}>
                  Policy <br /> Number
                </TableCell>
                <TableCell sx={CustomerStyle.tableCell}>
                  Effective Dates
                </TableCell>
                <TableCell sx={CustomerStyle.tableCell}>
                  Collision <br /> Comp
                </TableCell>
                {auth.user.loggedInAs === "manager" && (
                  <TableCell sx={CustomerStyle.tableCell}>Quote</TableCell>
                )}

                <TableCell sx={CustomerStyle.tableCell}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (
                <>
                  <TableRow>
                    <TableCell
                      sx={CustomerStyle.noBorder}
                      colSpan={auth.user.loggedInAs === "manager" ? 17 : 15}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          width: "100%",
                          margin: "16px",
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ height: "60vh" }}></TableRow>
                </>
              )}
              {tableData.length > 0 ? (
                tableData.map((row) => (
                  <CustomerCartComponent
                    key={row.customer.user_id}
                    customer={row}
                    hideEmployee={params.employeeId}
                    isEmployeeOnly={
                      auth.user.loggedInAs === "employee" || params.employeeId
                        ? true
                        : false
                    }
                    checkService={checkService}
                    walkthrough={walkthrough}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell
                    sx={CustomerStyle.noBorder}
                    colSpan={auth.user.loggedInAs === "manager" ? 17 : 15}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                        margin: "16px",
                      }}
                    >
                      <h2>No data to display</h2>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[20, 50]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, newPage) => {
            setPage(newPage);
          }}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </Paper>

      {/* Off-screen printable report: mirrors the visible table's columns
          using plain <table> markup so react-to-print can render it
          without depending on CustomerCartComponent's internal markup. */}
      <Box sx={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <Box ref={printRef} sx={{ p: 2 }}>
          <h2 style={{ marginBottom: 4 }}>
            {capitalizeFirstLetter(auth.user.dealership_name)} Customer Report
          </h2>
          <p style={{ marginTop: 0, marginBottom: 16 }}>
            Date Range: {filterData?.startDate} - {filterData?.endDate}
          </p>

          <table className="border" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f2f2f2" }}>
                <th className="p-6" style={{ textAlign: "left", padding: 6 }}>
                  Date
                </th>
                {auth.user.loggedInAs === "manager" && !params.employeeId && (
                  <th className="p-6" style={{ textAlign: "left", padding: 6 }}>
                    Employee
                  </th>
                )}
                <th className="p-6" style={{ textAlign: "left", padding: 6 }}>
                  Customer
                </th>
                <th className="p-6" style={{ textAlign: "left", padding: 6 }}>
                  Insurance Verified
                </th>
                {checkService?.knowledgeHub && (
                  <th className="p-6" style={{ textAlign: "left", padding: 6 }}>
                    Knowledge Hub
                  </th>
                )}
                {checkService?.idVerfication && (
                  <th className="p-6" style={{ textAlign: "left", padding: 6 }}>
                    ID Verified (P/F)
                  </th>
                )}
                {checkService?.prequal && (
                  <th className="p-6" style={{ textAlign: "left", padding: 6 }}>
                    PreQual Run
                  </th>
                )}
                <th className="p-6" style={{ textAlign: "left", padding: 6 }}>
                  Review
                </th>
                <th className="p-6" style={{ textAlign: "left", padding: 6 }}>
                  Satisfied
                </th>
                <th className="p-6" style={{ textAlign: "left", padding: 6 }}>
                  Appointment
                </th>
                <th className="p-6" style={{ textAlign: "left", padding: 6 }}>
                  Referral
                </th>
                <th className="p-6" style={{ textAlign: "left", padding: 6 }}>
                  Apps
                </th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, idx) => (
                <tr
                  key={row.customer?.user_id ?? idx}
                  style={{ backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f9f9f9" }}
                >
                  <td className="p-6" style={{ padding: 6 }}>
                    {row.customer?.date
                      ? moment(row.customer.date).format("MM/DD/YYYY hh:mm A")
                      : "-"}
                  </td>
                  {auth.user.loggedInAs === "manager" && !params.employeeId && (
                    <td className="p-6" style={{ padding: 6 }}>
                      {`${capitalizeFirstLetter(row.employee?.first_name) || ""} ${
                        capitalizeFirstLetter(row.employee?.last_name) || ""
                      }`.trim() || "-"}
                    </td>
                  )}
                  <td className="p-6" style={{ padding: 6 }}>
                    {`${capitalizeFirstLetter(row.customer?.first_name) || ""} ${
                      capitalizeFirstLetter(row.customer?.last_name) || ""
                    }`.trim() || "-"}
                  </td>
                  <td className="p-6" style={{ padding: 6 }}>
                    {row.customer?.insurance_verified ? "Yes" : "No"}
                  </td>
                  {checkService?.knowledgeHub && (
                    <td className="p-6" style={{ padding: 6 }}>
                      {row.customer?.knowledge_hub || "-"}
                    </td>
                  )}
                  {checkService?.idVerfication && (
                    <td className="p-6" style={{ padding: 6 }}>
                      N/A
                    </td>
                  )}
                  {checkService?.prequal && (
                    <td className="p-6" style={{ padding: 6 }}>
                      N/A
                    </td>
                  )}
                  <td className="p-6" style={{ padding: 6 }}>
                    {row.customer?.review || "-"}
                  </td>
                  <td className="p-6" style={{ padding: 6 }}>
                    {row.customer?.satisfied || "-"}
                  </td>
                  <td className="p-6" style={{ padding: 6 }}>
                    {row.customer?.appointment || "-"}
                  </td>
                  <td className="p-6" style={{ padding: 6 }}>
                    {row.customer?.referral || "-"}
                  </td>
                  <td className="p-6" style={{ padding: 6 }}>
                    {row.customer?.apps || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </Box>
    </Box>
  );
};

export default HocPopup(CustomersListComponent);